var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H1C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H26C26.5523 2 27 1.55228 27 1C27 0.447715 26.5523 0 26 0Z",
    fill: "#0A1E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H1C0.447715 15 0 15.4477 0 16C0 16.5523 0.447715 17 1 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15Z",
    fill: "#0A1E5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H1C0.447715 8 0 8.44772 0 9C0 9.55228 0.447715 10 1 10H26C26.5523 10 27 9.55228 27 9C27 8.44772 26.5523 8 26 8Z",
    fill: "#0A1E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.14ff97c0d4005abce9e5fb92c831ba70.svg";
export { ForwardRef as ReactComponent };